export enum POLICIES_DEFAULT_FIELDS {
  SMOKE_TYPE = 'Smoke Type',
  ALCOHOL_TYPE = 'Alcohol Type',
  PAIN_LOCATION = 'PAIN LOCATION',
  PAIN_SEVERITY = 'PAIN SEVERITY',
  CIRCUMSTANCE = 'CIRCUMSTANCE',
  PER = 'PER',
  PAID_BY = 'PAID_BY',
  PREGNANT_STAGE = 'PREGNANT_STAGE',
  OUTSIDE_COUNTRY = 'OUTSIDE_COUNTRY',
  ARTHRITIS_TYPE = 'ARTHRITIS TYPE',
  GYNECOLOGICAL_TYPE = 'GYNECOLOGICAL_TYPE',
  DISEASE_DOCUMENT = 'Disease Document',
  DOCTOR = 'DOCTOR',
  HOSPITAL = 'HOSPITAL',
  CCM_ENDPOINT = 'CCM_ENDPOINTS',
  EXPIRATION_SETUP = 'Expiration Setup',
  BANK_DETAILS = 'Bank Details',
  BRANCH_DETAILS = 'Branch Details',
  TREATMENT_OUTCOME = 'Treatment Outcome',
  HOSPITAL_CODE = 'HOSPITAL_CODE',
  DOCTOR_CODE = 'DOCTOR_CODE',
  PREFERRED_BY_CODE = 'PREFERRED_BY_CODE',
  // PAID_BY_CODE = 'PAID_BY_CODE',
  DOCUMENT_TYPES = 'DOCUMENT_TYPES',
  DOCUMENT_DELIVERY_ARRANGEMENTS = 'Document Delivery Arrangements',
  DATA_PROTECTION_NOTICE = 'Data Protection Notice',
  DECLARATION_AND_AUTHORIZATION = 'Declaration And Authorization',
  PROPOSAL_SECTION_DISPLAY_RULES = 'Proposal Section Display Rules',

  // Expiration Configurations
  EXPIRE_QUICK_QUOTE_INTO_QUOTE = 'QUICK TO QUOTE',
  EXPIRE_QUOTE_IN_PROGRESS_INTO_QUOTE = 'QUOTE PROGRESS TO QUOTE',
  EXPIRE_QUOTE__INTO_PROPOSAL = 'QUOTE TO PROPOSAL',

  //BROCHURES
  BROCHURES = 'BROCHURES',
}
